/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentViewQueryBestPracticeRisk extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentViewQueryBestPracticeRisk");
    }

    getFixupPrototypeFunction() { return AssessmentViewQueryBestPracticeRisk.fixupPrototype; }

    static newInstance(model: Partial<AssessmentViewQueryBestPracticeRisk>): AssessmentViewQueryBestPracticeRisk {
        let obj = Object.assign(new AssessmentViewQueryBestPracticeRisk(), model);
        AssessmentViewQueryBestPracticeRisk.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentViewQueryBestPracticeRisk>): AssessmentViewQueryBestPracticeRisk {
        if (!model) return null;
        return AssessmentViewQueryBestPracticeRisk.newInstance(<AssessmentViewQueryBestPracticeRisk> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentViewQueryBestPracticeRisk) {
        if (!obj) return;

        models.AssessmentViewQueryBestPracticeRisk.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentViewQueryBestPracticeRisk): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentViewQueryBestPracticeRisk.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Risk of best practice
     */
    best_practice_risks: Array<models.WellArchitectedFrameworkRisk>;

}
